import React from 'react'
import styled from 'styled-components'
import update from 'immutability-helper'
import {
  ListItem,
  ListItemText,
  Modal,
  List,
  Button,
  Grid,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import ReorderableList from './ReorderList'

const ResponseItem = styled(ListItem)`
  text-align: center;
`

class Response extends React.Component {
  constructor() {
    super()
    this.state = {
      open: false,
      customMessage: [],
      inputValue: '',
    }
  }

  isNewResponseEdit = () => {
    if (
      this.state.customMessage.length !==
      this.props.responseMessage.customMessage.length
    ) return true

    for (let i = 0; i < this.props.responseMessage.customMessage.length; i++) {
      if (
        this.state.customMessage[i].key !==
          this.props.responseMessage.customMessage[i].key ||
        this.state.customMessage[i].value !==
          this.props.responseMessage.customMessage[i].value
      ) return true
    }

    return false
  }

  updateResponseMessage = async () => {
    if (this.state.customMessage.length > 0 && this.isNewResponseEdit()) {
      await this.props.updateResponseMessage({
        name: this.props.responseMessage.name,
        message: this.state.customMessage,
      })
    }
    this.handleClose()
  }

  handleOpen = () => {
    this.setState({
      open: true,
      customMessage:
        this.props.responseMessage.customMessage.length !== 0
          ? this.reponseListFormat(this.props.responseMessage.customMessage)
          : this.reponseListFormat(this.props.responseMessage.defaultMessage),
    })
  }

  reponseListFormat = responseMessage => {
    return responseMessage.map((e, i) => ({
      id: i,
      type: e.type,
      value: e.value,
    }))
  }

  handleClose = () => {
    this.setState({
      open: false,
    })
  }

  handleOnClick = item => {
    const itemType = item.type.toLowerCase()
    if (itemType === 'text' && this.state.customMessage.length > 1) {
      const newCustomMessage = this.state.customMessage.filter(message => {
        return message.id !== item.id
      })

      this.setState({
        customMessage: newCustomMessage,
      })
    }
  }

  moveListItem = (dragIndex, hoverIndex) => {
    const {customMessage} = this.state
    const dragitem = customMessage[dragIndex]

    this.setState(
      update(this.state, {
        customMessage: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragitem]],
        },
      }),
    )
  }

  updateCustomMessage = text => {
    const newCustomeMessage = this.reponseListFormat([
      ...this.state.customMessage,
      {
        type: 'text',
        value: text,
      },
    ])
    this.setState({
      inputValue: '',
      customMessage: newCustomeMessage,
    })
  }

  updateInputValue = value => {
    this.setState({
      inputValue: value,
    })
  }

  render() {
    const ListItemLink = props => {
      return <ResponseItem button component="a" {...props} />
    }
    return (
      <div>
        <ListItemLink onClick={this.handleOpen}>
          <ListItemText primary={this.props.responseMessage.name} />
        </ListItemLink>
        <Modal open={this.state.open} onClose={this.handleClose}>
          <div
            style={{
              top: `${50}%`,
              left: `${50}%`,
              transform: `translate(-${50}%, -${50}%)`,
              position: 'absolute',
              background: 'white',
              border: '2px solid #000',
              outline: 'none',
            }}
          >
            <div style={{padding: '12px'}}>
              {this.props.responseMessage.name}
            </div>
            <div style={{padding: '12px'}}>
              Variable:{' '}
              {this.props.responseMessage.variable.map(e => {
                return `[Name: ${e.key}, Example: ${e.example}] `
              })}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Grid container>
                <Grid item xs={6}>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    Default Message
                  </div>
                  <List>
                    {this.props.responseMessage.defaultMessage.map(message => {
                      return (
                        <ListItem key={message.value}>{message.value}</ListItem>
                      )
                    })}
                  </List>
                </Grid>
                <Grid item xs={6}>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    CustomMessage
                  </div>
                  <ReorderableList
                    handleOnClick={this.handleOnClick}
                    variable={this.props.responseMessage.variable}
                    items={this.state.customMessage}
                    updateCustomMessage={this.updateCustomMessage}
                    moveListItem={this.moveListItem}
                    inputValue={this.state.inputValue}
                    updateInputValue={this.updateInputValue}
                  />
                </Grid>
              </Grid>
            </div>
            <Button onClick={this.updateResponseMessage}>ตกลง</Button>
          </div>
        </Modal>
      </div>
    )
  }
}

Response.propTypes = {
  responseMessage: PropTypes.object.isRequired,
  updateResponseMessage: PropTypes.func.isRequired,
}

export default Response



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/components/Response.js